import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { supabase } from '../lib/supabase';

export default function OrcamentoNovo() {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const [modalAberto, setModalAberto] = useState(false);
  const [sugestao, setSugestao] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [enviado, setEnviado] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(t);
  }, []);

  const handleEnviarSugestao = async () => {
    if (!sugestao.trim()) return;
    setEnviando(true);
    try {
      const { data: { user } } = await supabase.auth.getUser();
      await supabase.from('sugestoes').insert([{
        email: user?.email || 'anônimo',
        sugestao: sugestao.trim(),
        origem: 'orcamento_novo_sinapi',
        created_at: new Date().toISOString(),
      }]);
      setEnviado(true);
      setSugestao('');
    } catch (err) {
      console.error('Erro ao enviar sugestão:', err);
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-muted/30">
      <Header />

      <main className="flex-1 flex flex-col items-center justify-center px-4 pt-32 pb-16">
        {/* Bruno */}
        <div
          className="transition-all duration-700 ease-out"
          style={{ opacity: visible ? 1 : 0, transform: visible ? 'translateY(0)' : 'translateY(20px)' }}
        >
          <img
            src="/images/brand/bruno-principal.png"
            alt="Bruno"
            className="w-24 h-24 md:w-32 md:h-32 mx-auto object-contain"
          />
        </div>

        {/* Speech bubble */}
        <div
          className="mt-4 max-w-2xl mx-auto transition-all duration-700 delay-200 ease-out"
          style={{ opacity: visible ? 1 : 0, transform: visible ? 'translateY(0)' : 'translateY(12px)' }}
        >
          <div className="relative bg-card rounded-2xl shadow-card px-6 py-4 text-center">
            <div className="absolute -top-2 left-1/2 -translate-x-1/2 w-4 h-4 bg-card rotate-45 shadow-card" />
            <p className="relative text-secondary font-medium text-sm md:text-base leading-relaxed">
              Olá! Vou te ajudar a descobrir quanto vai custar sua obra. Primeiro me diz: <strong>o que você precisa hoje?</strong>
            </p>
          </div>
        </div>

        {/* Cards */}
        <div
          className="mt-10 w-full max-w-4xl grid grid-cols-1 md:grid-cols-2 gap-6 transition-all duration-700 delay-500 ease-out"
          style={{ opacity: visible ? 1 : 0, transform: visible ? 'translateY(0)' : 'translateY(20px)' }}
        >
          {/* Card 1 — Estimativa Rápida (CUB) */}
          <button
            onClick={() => navigate('/orcamento/planta?tipo=cub')}
            className="group bg-card rounded-2xl shadow-card p-6 md:p-8 text-left border-2 border-transparent hover:border-primary hover:shadow-elevated transition-all duration-300 cursor-pointer"
          >
            <div className="flex items-center gap-3 mb-3">
              <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
                <svg className="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <div>
                <h2 className="text-lg md:text-xl font-bold text-secondary font-display">Estimativa Rápida</h2>
                <p className="text-xs text-primary font-semibold">Resultado em 5 minutos</p>
              </div>
            </div>

            <p className="text-sm text-muted-foreground leading-relaxed mb-4">
              Ideal para quem está começando o projeto, quer ter uma ideia geral do investimento ou ainda não tem plantas detalhadas. Baseado no índice <strong className="text-foreground">CUB oficial</strong>.
            </p>

            <div className="flex items-center justify-between">
              <span className="inline-block text-xs font-semibold text-green-700 bg-green-100 px-3 py-1 rounded-full">
                Grátis para começar
              </span>
              <span className="text-sm font-semibold text-primary group-hover:translate-x-1 transition-transform duration-200 flex items-center gap-1">
                Quero uma estimativa
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </span>
            </div>
          </button>

          {/* Card 2 — Orçamento Detalhado (SINAPI) — EM BREVE */}
          <div
            onClick={() => setModalAberto(true)}
            className="relative bg-card rounded-2xl shadow-card p-6 md:p-8 text-left border-2 border-border opacity-70 cursor-pointer hover:opacity-80 transition-all duration-300"
          >
            {/* Badge Em Breve */}
            <div className="absolute -top-3 right-4">
              <span className="bg-amber-500 text-white text-xs font-bold px-4 py-1 rounded-full shadow-md">
                Em breve
              </span>
            </div>

            <div className="flex items-center gap-3 mb-3">
              <div className="w-12 h-12 rounded-xl bg-secondary/10 flex items-center justify-center flex-shrink-0">
                <svg className="w-6 h-6 text-secondary/50" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
              </div>
              <div>
                <h2 className="text-lg md:text-xl font-bold text-secondary/50 font-display">Orçamento Detalhado</h2>
                <p className="text-xs text-secondary/40 font-semibold">Resultado técnico e preciso</p>
              </div>
            </div>

            <p className="text-sm text-muted-foreground/70 leading-relaxed mb-4">
              Ideal para quem já tem plantas arquitetônica, estrutural, hidráulica e elétrica. Gera orçamento completo com composições e quantitativos. Baseado no <strong className="text-foreground/50">SINAPI oficial</strong>.
            </p>

            <div className="flex items-center justify-between">
              <span className="inline-block text-xs font-semibold text-amber-700 bg-amber-100 px-3 py-1 rounded-full">
                Em desenvolvimento
              </span>
              <span className="text-sm font-semibold text-muted-foreground flex items-center gap-1">
                Saiba mais
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </span>
            </div>
          </div>
        </div>

        {/* Bruno footer tip */}
        <div
          className="mt-10 transition-all duration-700 delay-700 ease-out"
          style={{ opacity: visible ? 1 : 0 }}
        >
          <p className="text-sm text-muted-foreground text-center max-w-lg mx-auto">
            Não tem certeza qual escolher? A <strong className="text-primary">Estimativa Rápida</strong> é o melhor começo! 😊
          </p>
        </div>
      </main>

      {/* Modal — Em Breve + Sugestão */}
      {modalAberto && (
        <div className="fixed inset-0 z-50 flex items-center justify-center px-4" onClick={() => setModalAberto(false)}>
          <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" />
          <div
            className="relative bg-card rounded-2xl shadow-elevated max-w-md w-full p-8 text-center"
            onClick={e => e.stopPropagation()}
          >
            {/* Fechar */}
            <button
              onClick={() => setModalAberto(false)}
              className="absolute top-4 right-4 text-muted-foreground hover:text-foreground transition-colors"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            {/* Ícone */}
            <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>

            <h3 className="font-display font-bold text-xl text-secondary mb-2">
              Estamos trabalhando nisso!
            </h3>
            <p className="text-muted-foreground text-sm mb-6 leading-relaxed">
              O Orçamento Detalhado com SINAPI está em desenvolvimento. 
              Avisaremos você assim que estiver disponível!
            </p>

            {/* Formulário de sugestão */}
            {!enviado ? (
              <div className="text-left">
                <label className="block text-xs font-semibold text-secondary mb-2">
                  Nos ajude a melhorar! Qual ferramenta você gostaria de ver no QCO?
                </label>
                <textarea
                  value={sugestao}
                  onChange={e => setSugestao(e.target.value)}
                  placeholder="Ex: Orçamento de reforma, cálculo de estrutura, cronograma de obra..."
                  rows={3}
                  className="w-full px-4 py-3 border border-border rounded-xl bg-muted text-sm text-foreground focus:ring-2 focus:ring-primary focus:border-transparent outline-none resize-none"
                />
                <button
                  onClick={handleEnviarSugestao}
                  disabled={!sugestao.trim() || enviando}
                  className="w-full mt-3 py-3 bg-primary text-white font-bold rounded-xl hover:bg-primary/90 transition-all disabled:opacity-50 disabled:cursor-not-allowed text-sm"
                >
                  {enviando ? 'Enviando...' : 'Enviar sugestão'}
                </button>
              </div>
            ) : (
              <div className="bg-green-50 border border-green-200 rounded-xl p-4">
                <div className="flex items-center justify-center gap-2 mb-1">
                  <svg className="w-5 h-5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="font-bold text-green-700 text-sm">Obrigado pelo feedback!</span>
                </div>
                <p className="text-xs text-green-600">Sua sugestão foi registrada e será analisada pela equipe.</p>
              </div>
            )}

            {/* Alternativa CUB */}
            <div className="mt-6 pt-4 border-t border-border">
              <p className="text-xs text-muted-foreground mb-3">
                Enquanto isso, experimente nossa Estimativa Rápida:
              </p>
              <button
                onClick={() => { setModalAberto(false); navigate('/orcamento/planta?tipo=cub'); }}
                className="w-full py-2.5 bg-primary/10 text-primary font-semibold rounded-xl hover:bg-primary/20 transition-all text-sm flex items-center justify-center gap-2"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
                Fazer Estimativa Rápida (CUB)
              </button>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}
